var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeartFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7662 1.2377C14.3753 0.845314 13.9111 0.534045 13.4002 0.321676C12.8893 0.109307 12.3417 0 11.7887 0C11.2357 0 10.6881 0.109307 10.1772 0.321676C9.66629 0.534045 9.20211 0.845314 8.81116 1.2377L7.99979 2.05166L7.18843 1.2377C6.39874 0.445478 5.32768 0.000410637 4.21089 0.000410646C3.09409 0.000410654 2.02303 0.445478 1.23334 1.2377C0.443646 2.02993 8.32078e-09 3.10441 0 4.22479C-8.32078e-09 5.34516 0.443646 6.41965 1.23334 7.21187L2.0447 8.02583L7.99979 14L13.9549 8.02583L14.7662 7.21187C15.1574 6.81967 15.4677 6.354 15.6793 5.84146C15.891 5.32893 16 4.77958 16 4.22479C16 3.67 15.891 3.12064 15.6793 2.60811C15.4677 2.09558 15.1574 1.62991 14.7662 1.2377Z",
    fill: "#C74454"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartFilled);
export default __webpack_public_path__ + "static/media/heart_filled.d35c8973.svg";
export { ForwardRef as ReactComponent };